import { COLORS } from 'consts/colors'
import styled, { css } from 'styled-components'

import { TTextType, ITextProps } from './types'
import { TEXT_STYLES } from './consts'

const ellipsisStyles = css`
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
  white-space: nowrap;
`

const numericStyles = css`
  font-variant-numeric: tabular-nums;
`

const getTextTypeStyles = (type: TTextType) => {
  return css`
    font-size: ${TEXT_STYLES[type].size};
    font-weight: ${TEXT_STYLES[type].weight};
  `
}

export const Text = styled.p<ITextProps>`
  ${props => getTextTypeStyles(props.$type)}
  letter-spacing: ${props => props?.$letterSpacing};
  line-height: ${props => props?.$lineHeight};
  text-align: ${props => props?.$align};
  font-weight: ${props => props?.$fontWeight};
  color: ${props => props?.$customColor || COLORS[props.$color] || ''};
  ${props => props?.$ellipsis && ellipsisStyles}
  ${props => props?.$isNumeric && numericStyles}
`
